import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';

import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';


class SidenavContent extends Component {
  componentDidMount() {
    const {history} = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`;// get current path

    const menuLi = document.getElementsByClassName('menu');
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, 'li');
          if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
            menuLi[j].classList.remove('open')
          }
        }
        this.classList.toggle('open');
      }
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  componentWillReceiveProps(nextProps) {

    const {history} = nextProps;
    const pathname = `${history.location.pathname}`;// get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] == 'function') {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {

    }

    return null;
  }

  render() {
    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">

          <li className="nav-header">
            <IntlMessages id="sidebar.main"/>
          </li>
          {/*<li className="menu collapse-box">
            <NavLink to="/app/home">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.home"/> </span>
            </NavLink>
			<ul className="sub-menu">
				<li>
					<NavLink to="/app/sample-page">
						<span className="nav-text"><IntlMessages id="pages.samplePage"/> </span>
					</NavLink>
				</li>
				<li>
					<NavLink to="/app/test">
						<span className="nav-text"><IntlMessages id="pages.samplePage"/> </span>
					</NavLink>
				</li>
			</ul>
		  </li>*/}
          <li className="menu no-arrow">
			<NavLink to="/app/home">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.home"/> </span>
            </NavLink>
          </li>
		  <li className="menu no-arrow">
			<NavLink to="/app/projects">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.projects"/> </span>
            </NavLink>
          </li>
		  <li className="menu no-arrow">
			<NavLink to="/app/companies">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.companies"/> </span>
            </NavLink>
          </li>
		  <li className="menu no-arrow">
			<NavLink to="/app/teams">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.teams"/> </span>
            </NavLink>
          </li>
		  <li className="menu no-arrow">
			<NavLink to="/app/users">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.users"/> </span>
            </NavLink>
          </li>
		  <li className="menu no-arrow">
			<NavLink to="/app/certificates">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.certificates"/> </span>
            </NavLink>
          </li>
		  <li className="menu no-arrow">
			<NavLink to="/app/medicals">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.medicals"/> </span>
            </NavLink>
          </li>
		  <li className="menu no-arrow">
			<NavLink to="/app/jobs">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.jobs"/> </span>
            </NavLink>
          </li>
		  <li className="menu no-arrow">
			<NavLink to="/app/activities">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.activities"/> </span>
            </NavLink>
          </li>
		  <li className="menu no-arrow">
			<NavLink to="/app/procedures">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.procedures"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/inspections">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.inspections"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/surveys">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.surveys"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/trainings">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.trainings"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/non-compliances">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.non_compliances"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/incidents">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.incidents"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/environments">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.environments"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/equipment">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.equipment"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/injuries">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.injuries"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/permits">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.permits"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/ppes">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.ppes"/> </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
			<NavLink to="/app/works">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"><IntlMessages id="pages.works"/> </span>
            </NavLink>
          </li>
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(SidenavContent);
